import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const WomanBoy = (props: Icon): React.ReactElement =>
  props.variant === "line" ? (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path
          d="M10 16c.342 0 .624.257.662.589l.005.078v2.666a.667.667 0 01-1.33.078l-.004-.078v-2.666c0-.369.299-.667.667-.667zm-2.667 0c.342 0 .624.257.663.589l.004.078v2.666a.667.667 0 01-1.329.078l-.004-.078v-2.666c0-.369.298-.667.666-.667zm9.334.667c.342 0 .623.257.662.589l.004.077v2a.667.667 0 01-1.329.078L16 19.333v-2c0-.368.298-.666.667-.666zm-8-6.667a3.16 3.16 0 013.05 2.332l.034.143.9 4.047a.667.667 0 01-1.28.364l-.022-.075-.9-4.047a1.826 1.826 0 00-3.537-.113l-.029.113-.899 4.047A.667.667 0 014.67 16.6l.013-.077.899-4.047A3.16 3.16 0 018.667 10zm8 2.667a2.667 2.667 0 012.666 2.666.667.667 0 01-1.329.078L18 15.333a1.333 1.333 0 10-2.667 0 .667.667 0 01-1.333 0 2.667 2.667 0 012.667-2.666zm0-4.667a2 2 0 110 4 2 2 0 010-4zm0 1.333a.667.667 0 100 1.334.667.667 0 000-1.334zM8.667 4a2.333 2.333 0 110 4.667 2.333 2.333 0 010-4.667zm0 1.333a1 1 0 100 2 1 1 0 000-2z"
          id="womanboy_line_a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="womanboy_line_b" fill="#fff">
          <use xlinkHref="#womanboy_line_a" />
        </mask>
        <use fill="#FFF" fillRule="nonzero" xlinkHref="#womanboy_line_a" />
        <g
          mask="url(#womanboy_line_b)"
          fill={props.color || theme.palette.grey600}
        >
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  ) : (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          d="M10 16c.342 0 .624.257.662.589l.005.078v2.666a.667.667 0 01-1.33.078l-.004-.078v-2.666c0-.369.299-.667.667-.667zm-2.667 0c.342 0 .624.257.663.589l.004.078v2.666a.667.667 0 01-1.329.078l-.004-.078v-2.666c0-.369.298-.667.666-.667zm9.334.667c.342 0 .623.257.662.589l.004.077v2a.667.667 0 01-1.329.078L16 19.333v-2c0-.368.298-.666.667-.666zm-8-6.667a3.16 3.16 0 013.05 2.332l.034.143.9 4.047a.667.667 0 01-1.28.364l-.022-.075-.9-4.047a1.826 1.826 0 00-3.537-.113l-.029.113-.899 4.047A.667.667 0 014.67 16.6l.013-.077.899-4.047A3.16 3.16 0 018.667 10zm8 2.667a2.667 2.667 0 012.666 2.666.667.667 0 01-1.329.078L18 15.333a1.333 1.333 0 10-2.667 0 .667.667 0 01-1.333 0 2.667 2.667 0 012.667-2.666zm0-4.667a2 2 0 110 4 2 2 0 010-4zm0 1.333a.667.667 0 100 1.334.667.667 0 000-1.334zM8.667 4a2.333 2.333 0 110 4.667 2.333 2.333 0 010-4.667zm0 1.333a1 1 0 100 2 1 1 0 000-2z"
          id="womanboy_solid_a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="womanboy_solid_b" fill="#fff">
          <use xlinkHref="#womanboy_solid_a" />
        </mask>
        <use fill="#FFF" fillRule="nonzero" xlinkHref="#womanboy_solid_a" />
        <g
          mask="url(#womanboy_solid_b)"
          fill={props.color || theme.palette.grey600}
        >
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  );
